import { getServiceUrl, getServicesAppUrl } from '../utils/externalPages';

export const PATHS = {
  home: { path: '/', title: 'Home' },
  login: {
    path: `${getServiceUrl()}/auth?redirect=/comercios`,
    localPath: '/auth',
    title: 'Auth',
  },
  registration: {
    path: `${getServiceUrl()}/auth/registration`,
    localPath: '/auth/registration',
    title: 'Registro',
  },
  cashIn: { path: '/cash-in', title: 'cashIn' },
  cashOut: { path: '/cash-out', title: 'cashOut' },
  payments: { path: '/payments', title: 'payments' },
  wallet: { path: '/wallet', title: 'pos' },
  liquidations: { path: '/wallet/liquidations', title: 'liquidations' },
  liquidationRequest: {
    path: '/wallet/liquidation-request',
    title: 'requestToLiquidation',
  },
  movements: { path: '/wallet/movements', title: 'movementsHistory' },
  profile: { path: '/profile', title: 'profile' },
  aboutUs: { path: '/about-us', title: '¡Quiénes Somos!' },
  contact: { path: '/contact', title: 'Contacto' },
  termsAndConditions: {
    path: `${getServicesAppUrl()}/terms-and-conditions`,
    localPath: '/terms',
    title: 'termAndConditions',
  },
  privacyPolicy: {
    path: `${getServicesAppUrl()}/privacy`,
    localPath: '/privacy',
    title: 'Políticas de privacidad',
  },
  frequentQuestions: {
    path: '/frequent-questions',
    title: 'Preguntas frecuentes',
  },
  confirmation: { path: '/confirm', title: 'Confirmación' },
  passwordRecovery: { path: '/auth/recovery', title: 'Recuperar contraseña' },
  ChangePasswor: { path: '/auth/change-password', title: 'Cambiar contraseña' },
  reports: { path: '/reports', title: 'reports' },
  reportsHistory: { path: '/reports/history', title: 'reportsHistory' },
  sharedAuth: { path: '/shared-auth', title: 'sharedAuth' },
};

export const URL_SANDBOX = [
  '/internal/v1/merchants/operations',
  '/internal/v1/merchants/integrations',
  '/internal/v1/merchants/integrations/request_to_enable',
];

export const BASE_URL = {
  staging: 'https://staging-app.kriptonmarket.com/',
  sandbox: 'https://sandbox.app.kriptonmarket.com',
  prod: 'https://app.kriptonmarket.com/',
};

export const SOCKET_BASE_URL = {
  staging: 'wss://staging-app.kriptonmarket.com/cable',
  prod: 'wss://app.kriptonmarket.com/cable',
};
